/**
 * Google Ads conversion tracking helper.
 * Wraps `window.gtag_report_conversion` (defined in /public/index.html)
 * so that WhatsApp / phone clicks fire a conversion event before the redirect.
 *
 * Usage:
 *   <a href={url} onClick={trackConversion(url)}>...</a>
 *
 * Falls back to the default link behaviour if gtag has not yet loaded
 * (ad-blocker, slow network…) so the user always reaches the destination.
 */
export const trackConversion = (url) => (e) => {
  if (typeof window === "undefined") return;
  const fn = window.gtag_report_conversion;
  if (typeof fn !== "function") return; // let the browser follow the link
  e.preventDefault();
  fn(url);
};
